import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="price-lists--site-tasks--form"
export default class extends Controller {
  connect() {
    this.updateVariant()
  }

  updateVariant() {
    const hasVariants = this.element.querySelector('[data-form-estimate-variant]:not(.d-none)')
    if (hasVariants) {
      console.log('hasVariants')
      this.element.querySelectorAll('[data-hide-if-variants]').forEach(el => {
        el.classList.add('d-none')
      })
    } else {
      console.log('no variants')
      this.element.querySelectorAll('[data-hide-if-variants]').forEach(el => {
        el.classList.remove('d-none')
      })
    }
  }
}
